import { ElementType, KeyboardEvent, MouseEvent } from 'react';
import {
  List,
  ListItem,
  Box,
  IconButton,
  ListItemIcon,
  styled,
  ListItemText,
  Drawer,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { HEADER_HEIGHT } from '../../_constants/styleConst';
import { useTranslation } from 'react-i18next';
import { VERSION } from '../../version';

type SideMenuProps = {
  isOpen: boolean;
  menuItems: {
    label: string;
    path: string;
    icon: ElementType;
  }[];
  onClickClose: (event: KeyboardEvent | MouseEvent) => void;
  onClickNavigate: (path: string) => void;
};

const SideMenuListItem = styled(ListItem, {
  shouldForwardProp: (prop) => prop !== 'theme',
})(({ theme }) => ({
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

/** ハンバーガーメニューで開くサイドメニュー */
const SideMenu: React.FC<SideMenuProps> = ({
  isOpen,
  menuItems,
  onClickClose,
  onClickNavigate,
}) => {
  const { t } = useTranslation();
  return (
    <Drawer
      anchor="left"
      open={isOpen}
      onClose={onClickClose}
      sx={{
        top: HEADER_HEIGHT,
        '& .MuiDrawer-paper': {
          height: '100%',
          bgcolor: 'primary.main',
          color: '#FFF',
        },
        position: 'relative',
      }}
    >
      <Box sx={{ width: 'fit-content', minWidth: '200px' }} role="presentation">
        <List>
          <ListItem sx={{ pr: '5px' }}>
            <IconButton
              onClick={onClickClose}
              sx={{ ml: 'auto', py: '0.5rem' }}
            >
              <CloseIcon sx={{ color: '#FFF' }} />
            </IconButton>
          </ListItem>
          {menuItems.map((item, i) => (
            <SideMenuListItem
              key={`side_menu_${i}`}
              onClick={() => onClickNavigate(item.path)}
            >
              <ListItemIcon sx={{ minWidth: '1rem', marginRight: '0.5rem' }}>
                <item.icon sx={{ color: '#FFF' }} />
              </ListItemIcon>
              <ListItemText primary={`${t(item.label)}`} />
            </SideMenuListItem>
          ))}
        </List>
      </Box>
      <Box sx={{ position: 'absolute', bottom: '0.5rem', right: '1rem' }}>
        <Typography fontSize={'0.8rem'}>{'Ver.' + VERSION.CURRENT}</Typography>
      </Box>
    </Drawer>
  );
};

export default SideMenu;
